module.exports = __webpack_public_path__ + "3ee7dadfab40f3e3b18c7c14fff6f86d.svg";